/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Fallback_Project_Import_ToastInputs */

const en_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Using project file import method`)
};

const fr_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisation de la methode d'import du fichier projet`)
};

const de_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwendung der Projektdatei-Importmethode`)
};

const it_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizzo del metodo di importazione del file di progetto`)
};

const ru_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использование метода импорта файлов проекта`)
};

const es_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso del método de importación de archivos de proyecto`)
};

const zh_cn2_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用项目文件导入方法`)
};

const ja_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトファイルのインポート方法を使用する`)
};

const hi_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइल आयात विधि का उपयोग करना`)
};

const pt_pt2_explorer_table_fallback_project_import_toast = /** @type {(inputs: Explorer_Table_Fallback_Project_Import_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizando o método de importação de arquivo de projeto`)
};

/**
* | output |
* | --- |
* | "Using project file import method" |
*
* @param {Explorer_Table_Fallback_Project_Import_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_fallback_project_import_toast = /** @type {((inputs?: Explorer_Table_Fallback_Project_Import_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Fallback_Project_Import_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_fallback_project_import_toast(inputs)
	if (locale === "de") return de_explorer_table_fallback_project_import_toast(inputs)
	if (locale === "it") return it_explorer_table_fallback_project_import_toast(inputs)
	if (locale === "ru") return ru_explorer_table_fallback_project_import_toast(inputs)
	if (locale === "es") return es_explorer_table_fallback_project_import_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_fallback_project_import_toast(inputs)
	if (locale === "ja") return ja_explorer_table_fallback_project_import_toast(inputs)
	if (locale === "hi") return hi_explorer_table_fallback_project_import_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_fallback_project_import_toast(inputs)
	return en_explorer_table_fallback_project_import_toast(inputs)
});